<template>
  <div :class="[$style.container, 'language_dropdown']">
    <dropdown align="right">
      <template slot="label">
        <img
          :src="selectedLocale.icon"
          alt=""
          :class="$style.dropdownButtonIcon"
        >
      </template>
      <template slot="panel">
        <div :class="$style.dropdownPanel">
          <language-switch
            :profiles="profiles"
            :locales="locales"
            :container-class="$style.languageContainer"
            :active-class="$style.languageItemActiveState"
            :item-class="$style.languageItem"
            :label-class="$style.languageItemLabel"
            :icon-class="$style.languageItemIcon"
            @change="localeChangeHandler"
          />
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script>
  import localeManger from '@services/LocaleManager'
  import LocaleCollection from '@models/Locale/collection'
  import ProfileCollection from '@models/Profile/collection'
  import DropdownComponent from '@components/Dropdown'
  import LanguageSwitchComponent from '@components/LanguageSwitch'

  export default {
    components: {
      dropdown: DropdownComponent,
      languageSwitch: LanguageSwitchComponent
    },
    props: {
      locales: {
        type: LocaleCollection,
        required: true
      },
      profiles: {
        type: ProfileCollection
      }
    },
    data () {
      return {
        selectedLocale: localeManger.getLocale()
      }
    },
    methods: {
      localeChangeHandler (e, locale) {
        this.setSelectedLocale(locale)
      },
      setSelectedLocale (locale) {
        this.$set(this, 'selectedLocale', locale)
        return this
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/vars";
  @import "~@stylesheets/includes/mixins";

  /**
   * Container
   */
  .container {
    display: flex;
  }

  /**
   * Dropdown button icon
   */
  .dropdownButtonIcon {
    display: block;
    width: 22px;
    height: 15px;
    box-shadow: 0px 1px 7px 0 rgba(27, 29, 32, 0.15);
  }

  /**
   * Dropdown panel
   */
  .dropdownPanel {
    width: 165px;
  }

  /**
   * Language items container
   */
  .languageContainer {

  }

  /**
   * Language item
   */
  .languageItem {
    display: block;
    text-decoration: none;
    padding: 8px 30px;
    opacity: .7;
    transition: opacity .3s;

    &:first-child {
      padding-top: 22px;
    }

    &:last-child {
      padding-bottom: 26px;
    }
  }

  /**
   * Language item hover state
   */
  .languageItem:hover {
    opacity: 1;
  }

  /**
   * Language item active state
   */
  .languageItemActiveState {
    font-weight: bold;
    opacity: 1;
    cursor: default;
  }

  /**
   * Language item icon
   */
  .languageItemIcon {
    position: relative;
    top: 1px;
    display: inline-block;
    vertical-align: middle;
    width: 22px;
    margin-right: 8px;
    box-shadow: 0px 1px 7px 0 rgba(27, 29, 32, 0.15);
  }

  /**
   * Language item label
   */
  .languageItemLabel {
    vertical-align: middle;
    color: #2d3e50;
    font-size: 15px;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/LanguageDropdown.vue